import React from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';
import { Link } from 'gatsby';
import { ParameterRow } from '@irvin-group/airtable-data-types';

interface Props { }


export default class ServiceHighlights extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const records = data.pageParameters.getArray('ServiceHighlight');

    return (
      <div className="flex flex-row justify-center bg-near-white bb b--light-gray">
        <div className="wfull flex-l flex-row mv4 mv5-ns mh3 bt bw2 theme--primary-border-color">

          { records.map(r =>
            <section key={ r.Value } className="bg-white ba b--light-gray pv3 ph3 ph4-ns flex flex-column">
              <h3 className="ttu tc">{ r.Value }</h3>
              <p className="lh-copy flex-auto">{ r.Content }</p>
              <p className="tc mt5 mb3">
                <Link to="/services" className="link dim ttu bg-light-gray gray b pv2 ph3">Learn More</Link>
              </p>
            </section>
          ) }

        </div>
      </div>
    );
  }

}